import React from "react";
import useTheme from "@mui/material/styles/useTheme";

import {shortStringWithDayName} from "../../../services/date/formatters";
import PeopleTag from "../../../components/PeopleTag";

import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";


const PriceList = function ({accommodations, availableAccommodationUnitPrices}) {
    const theme = useTheme();

    const notAvailableAccommodations = accommodations.accommodationUnits.filter(
        accUnit => !availableAccommodationUnitPrices.some(ap => ap.accommodationId === accUnit.id && ap.accommodationType === accUnit.type)
    );

    return <>
        <Typography variant='h6' sx={{mt: 2}}>Disponibilità e prezzi</Typography>
        <List>
            {
                availableAccommodationUnitPrices.map((accUnitPrice, i) => (
                    <ListItemPrices key={i} accommodationUnitPrices={accUnitPrice} accommodations={accommodations}/>
                ))
            }
            {
                notAvailableAccommodations.map((unit, i) => {
                    return <ListItem key={`not-available-${i}`}>
                        <Stack width="100%" sx={{pl: 1, borderLeft: `3px solid ${theme.palette.error.main}`, minHeight: "40px"}}
                               justifyContent="center">
                            <Typography>
                                {unit.name} ({unit.accommodation.name})
                            </Typography>
                            <Typography variant="body2" color="text.primary">
                                Occupato
                            </Typography>
                        </Stack>

                    </ListItem>
                })
            }
        </List>
    </>
}

const ListItemPrices = ({accommodations, accommodationUnitPrices}) => {
    const theme = useTheme();
    const accommodationUnit = accommodations.findAccommodationUnit(accommodationUnitPrices.accommodationType, accommodationUnitPrices.accommodationId);
    const minPeoplePrice = accommodationUnitPrices.getMinPeople();
    const maxPeoplePrice = accommodationUnitPrices.getMaxPeople();

    let priceInfo = "(Prezzi non disponibili)";
    if(minPeoplePrice && maxPeoplePrice) {
        if (minPeoplePrice === maxPeoplePrice) {
            priceInfo = `(Prezzo per ${minPeoplePrice} persone)`;
        }else{
            priceInfo = `(Prezzi da ${minPeoplePrice} a ${maxPeoplePrice} persone)`;
        }
    }

    const [isOpen, toggleIsOpen] = React.useReducer(oldState => !oldState, false);

    return <ListItem>
        <Stack width="100%" sx={{pl: 1, borderLeft: `3px solid ${theme.palette.success.light}`}}>
            <Stack direction="row" justifyContent="space-between"
                   alignItems="center">
                <Stack>
                    <Typography>
                        {accommodationUnit.name} ({accommodationUnit.accommodation.name})
                    </Typography>
                    <Typography variant="body2" color="text.primary">
                        {shortStringWithDayName(accommodationUnitPrices.arrival)} - {shortStringWithDayName(accommodationUnitPrices.departure)}
                    </Typography>
                    <Typography variant="body2" color="text.primary">
                        Disponibile {priceInfo}
                    </Typography>
                </Stack>
                {
                    accommodationUnitPrices.hasValidPrices() && <IconButton onClick={toggleIsOpen}>
                        {isOpen ? <ExpandLessIcon/> : <ExpandMoreIcon/>}
                    </IconButton>
                }
            </Stack>
            {
                isOpen && <Stack spacing={1} mt={2}>
                    {
                        accommodationUnitPrices.prices.map((price, i) => {
                            return <Stack key={i} direction="row" justifyContent="space-between"
                                          alignItems="center">
                                <PeopleTag peopleNumber={price.people} variant="contained" iconSize="small" color="text.primary"/>
                                <Typography color="text.primary">{price.getPrice()} €</Typography>
                            </Stack>
                        })
                    }
                </Stack>
            }
        </Stack>
    </ListItem>
}

export default PriceList;